import React from "react"
import styles from "./Banner.module.css"
import heroBackground from "./images/partnership-hero-indonesia.jpg"

const Banner = ({ onInfoClick }) => {
  return (
    <section className={styles.hero}>
      <img
        className={styles.heroBackground}
        src={heroBackground}
        alt="Fasilitator Mindo Education memandu pelatihan bersama tim perusahaan"
      />

      <div className={styles.heroCopy}>
        <h1>
          <span>Upgrade skill,</span>
          <span className={styles.heroTitleSecondLine}>
            naik level <em>bersama tim.</em>
          </span>
        </h1>
        <p className={styles.heroLead}>
          Program pelatihan dan pendampingan yang dirancang sesuai kebutuhan
          nyata organisasi Anda.
        </p>
        <div className={styles.heroActions}>
          <a
            href="#contact"
            className={`${styles.button} ${styles.buttonPrimary}`}
            onClick={onInfoClick}>
            Konsultasi GRATIS sekarang
          </a>
        </div>
      </div>

      <div
        className={styles.heroPrograms}
        aria-label="Program partnership tersedia">
        <div className={styles.heroProgramItem}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 20V9l8-5 8 5v11M8 20v-6h8v6M2 20h20" />
          </svg>
          <span>In-house Training</span>
        </div>
        <div className={styles.heroProgramItem}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3 4 6v5c0 5 3.4 8.3 8 10 4.6-1.7 8-5 8-10V6l-8-3Z" />
            <path d="m8.5 12 2.2 2.2 4.8-5" />
          </svg>
          <span>Pendampingan Sertifikasi</span>
        </div>
        <div className={styles.heroProgramItem}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m3 9 9-5 9 5-9 5-9-5Z" />
            <path d="M6 11v5c2.8 2.4 9.2 2.4 12 0v-5M21 9v6" />
          </svg>
          <span>Campus Partner</span>
        </div>
      </div>

      <div
        className={styles.heroProgramsCards}
        aria-label="Pilihan program partnership">
        <a
          className={`${styles.heroProgramCard} ${styles.isFeatured}`}
          href="#program">
          <span className={styles.heroProgramNumber}>01</span>
          <span className={styles.heroProgramCardCopy}>
            <strong>In-house Training</strong>
            <small>Pelatihan sesuai kebutuhan tim</small>
          </span>
          <span className={styles.heroProgramArrow} aria-hidden="true">
            ↗
          </span>
        </a>
        <a className={styles.heroProgramCard} href="#program">
          <span className={styles.heroProgramNumber}>02</span>
          <span className={styles.heroProgramCardCopy}>
            <strong>Pendampingan Sertifikasi</strong>
            <small>Siap menghadapi standar industri</small>
          </span>
          <span className={styles.heroProgramArrow} aria-hidden="true">
            ↗
          </span>
        </a>
        <a className={styles.heroProgramCard} href="#program">
          <span className={styles.heroProgramNumber}>03</span>
          <span className={styles.heroProgramCardCopy}>
            <strong>Campus Partner</strong>
            <small>Kolaborasi untuk talenta masa depan</small>
          </span>
          <span className={styles.heroProgramArrow} aria-hidden="true">
            ↗
          </span>
        </a>
      </div>

      <div
        className={styles.heroProgramsIcons}
        aria-label="Pilihan program partnership">
        <a
          className={`${styles.heroIconChip} ${styles.isFeatured}`}
          href="#program">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 20V9l8-5 8 5v11M8 20v-6h8v6M2 20h20" />
          </svg>
          <span>In-house Training</span>
        </a>
        <a className={styles.heroIconChip} href="#program">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3 4 6v5c0 5 3.4 8.3 8 10 4.6-1.7 8-5 8-10V6l-8-3Z" />
            <path d="m8.5 12 2.2 2.2 4.8-5" />
          </svg>
          <span>Pendampingan Sertifikasi</span>
        </a>
        <a className={styles.heroIconChip} href="#program">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m3 9 9-5 9 5-9 5-9-5Z" />
            <path d="M6 11v5c2.8 2.4 9.2 2.4 12 0v-5M21 9v6" />
          </svg>
          <span>Campus Partner</span>
        </a>
      </div>

      <div className={styles.heroNote}>#UnggulBersama</div>
    </section>
  )
}

export default Banner
